import { CSSProperties } from 'react';
import { Color, Size, Styles } from '@vivli/shared/theme';
import { LinkButtonView } from '@vivli/shared/components';
import { AssetsConstant, DTIActiveUserMenu } from '@vivli/shared/infrastructure/constants';

const VIVLI_ORG_URL = 'https://vivli.org';
const VIVLI_ORG_TITLE = 'Vivli.org';

const containerStyle: CSSProperties = {
    ...Styles.NO_SELECT,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: Size.HEADER_HEIGHT
};

const popoutTargetImgContainerStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    paddingLeft: 0,
    paddingRight: 0,
    borderTopRightRadius: Size.BORDER_RADIUS,
    borderBottomRightRadius: Size.BORDER_RADIUS,
    borderTopLeftRadius: Size.BORDER_RADIUS,
    borderBottomLeftRadius: Size.BORDER_RADIUS,
    ...Styles.Transition.HOVER_OPACITY_TRANSITION
};

const navButtonStyle: CSSProperties = {
    width: 'auto',
    fontWeight: Size.FontWeight.ExtraBold
};

export const VivliOrgNavView = () => {
    return (
        <div style={containerStyle} className="external_links_menu" data-test-id={DTIActiveUserMenu.MainMenu}>
            <div
                key="vivli-org-nav"
                style={{
                    ...popoutTargetImgContainerStyle,
                    gap: 6
                }}
            >
                <img src={AssetsConstant.navigateVivliOrg} alt="Vivli.org" style={{ width: '20px', marginRight: 0, flexShrink: 0 }} />
                <LinkButtonView
                    title={VIVLI_ORG_TITLE}
                    style={navButtonStyle}
                    onClick={() => window.open(VIVLI_ORG_URL, '_blank')}
                    disabled={false}
                    dataId="vivli-link"
                    keepVisitedColor
                >
                    {VIVLI_ORG_TITLE}
                </LinkButtonView>
            </div>
        </div>
    );
};
